<template>
  <ts-dialog :visible.sync="visible">
    <div class="flex flex-col items-center justify-center">
      <h1 class="mb-4">Your assets have been uploaded and will be available for download soon !</h1>
      <ts-button size="large" @click.prevent="visible = false"> Close </ts-button>
    </div>
  </ts-dialog>
</template>

<script>
export default {
  name: 'DownloadSuccessDialog',
  data() {
    return {
      visible: false
    };
  },
  created() {
    window.EventBus.$on('download.success', () => {
      this.visible = true;
    });
  }
};
</script>

<style>
</style>